class DualButtonsController {
  constructor(section) {
    this.section = section;
    this.targetSelectors = this.section.dataset.targetSelectors || '';
    this.toggleClass = this.section.dataset.toggleClass || 'active';
    this.buttons = this.section.querySelectorAll('.dual-buttons__btn');
    this.targetElements = [];
    
    this.init();
  }

  init() {
    this.parseTargetSelectors();
    
    this.bindEvents();
    
    console.log('DualButtonsController initialized:', {
      targetSelectors: this.targetSelectors,
      toggleClass: this.toggleClass,
      targetElements: this.targetElements.length
    });
  }

  parseTargetSelectors() {
    if (!this.targetSelectors) return;
    
    const selectors = this.targetSelectors
      .split(',')
      .map(selector => selector.trim())
      .filter(selector => selector.length > 0);
    
    selectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        this.targetElements.push(...elements);
      } catch (error) {
        console.warn(`Invalid selector: ${selector}`, error);
      }
    });
  }

  bindEvents() {
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.handleButtonClick(e);
      });
    });
  }

  handleButtonClick(event) {
    const clickedButton = event.currentTarget;
    const buttonNumber = clickedButton.dataset.button;
    
    this.buttons.forEach(btn => {
      btn.classList.remove('active');
    });
    
    clickedButton.classList.add('active');
    
    if (buttonNumber === '1') {
      this.handleButton1Click();
    } else if (buttonNumber === '2') {
      this.handleButton2Click();
    }
    
    this.onButtonClick(buttonNumber, clickedButton);
  }

  handleButton1Click() {
    console.log('Button 1 clicked');

    document.querySelectorAll('.section-columns__slider.carousel.grid--mobile').forEach(el => {
      el.classList.remove('grid--mobile-1-col');
    })
    
    this.targetElements.forEach(element => {
      element.classList.add(this.toggleClass);
    });
    
    this.dispatchCustomEvent('button1:click', {
      targetElements: this.targetElements,
      toggleClass: this.toggleClass
    });
  }

  handleButton2Click() {
    console.log('Button 2 clicked');

    document.querySelectorAll('.section-columns__slider.carousel.grid--mobile').forEach(el => {
      el.classList.add('grid--mobile-1-col');
    })
    
    this.targetElements.forEach(element => {
      element.classList.remove(this.toggleClass);
    });
    
    this.dispatchCustomEvent('button2:click', {
      targetElements: this.targetElements,
      toggleClass: this.toggleClass
    });
  }

  onButtonClick(buttonNumber, buttonElement) {
    // Этот метод можно переопределить для дополнительной логики
  }

  dispatchCustomEvent(eventName, detail) {
    const event = new CustomEvent(eventName, {
      detail: detail,
      bubbles: true,
      cancelable: true
    });
    
    this.section.dispatchEvent(event);
  }

  clickButton(buttonNumber) {
    const button = this.section.querySelector(`[data-button="${buttonNumber}"]`);
    if (button) {
      button.click();
    }
  }

  addTargetElements(selectors) {
    if (Array.isArray(selectors)) {
      selectors.forEach(selector => {
        try {
          const elements = document.querySelectorAll(selector);
          this.targetElements.push(...elements);
        } catch (error) {
          console.warn(`Invalid selector: ${selector}`, error);
        }
      });
    } else if (typeof selectors === 'string') {
      this.addTargetElements([selectors]);
    }
  }

  getState() {
    return {
      activeButton: this.section.querySelector('.dual-buttons__btn.active')?.dataset.button || null,
      targetElements: this.targetElements,
      toggleClass: this.toggleClass
    };
  }

  destroy() {
    this.buttons.forEach(button => {
      button.removeEventListener('click', this.handleButtonClick);
    });
  }
}

window.DualButtonsController = DualButtonsController;

document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('[data-section-type="dual-buttons"]');
  
  sections.forEach(section => {
    if (!section.dualButtonsController) {
      section.dualButtonsController = new DualButtonsController(section);
    }
  });
});